// extracted by mini-css-extract-plugin
export var cardSelected = "_h3-2";
export var image = "_h3-1";
export var table = "_h3-0";